<script>
  import moment from "moment";
  import Carousel from "svelte-carousel";
  import { Basket } from "../../lib/stores/basket";
  import { notifications } from "../../lib/stores/notifications";
  import { track } from "fbq";
  import Datepicker from "svelte-calendar";
  import Products from "../../models/Products";
  import { Swipe, SwipeItem } from "svelte-swipe";
  import ListItem from "../../lib/components/products/ListItem.svelte";
    import { onMount } from "svelte";
  const swipeConfig = {
	autoplay: true,
	delay: 2000,
	showIndicators: true,
	transitionDuration: 1000,
	defaultIndex: 0,
  };
  var isMobile = navigator.userAgent.match(
	/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i
  );
  export let id;
  let product = false;
  let similar_products = [];
  let selectedImage;
  let update = false;
  let date = $Basket.deleveryDate;
  if (!isMobile) {
	date = $Basket.deleveryDate
	  ? moment($Basket.deleveryDate).toDate() == "Invalid Date"
		? new Date()
		: moment($Basket.deleveryDate).toDate()
	  : new Date();
  }
  fetch(`https://crm.lamara.in/products/products/getproductbytitle/${id}`)
	.then((res) => res.json())
	.then((res) => {
	  product = res.data.product_info;
	  similar_products = res.data.similar_products;
	  track("ViewContent", {
		content_ids: [product.item_no],
		content_category: "cakes",
		content_name: product.name,
		content_type: "product",
		currency: "INR",
		value:
		  product.pricelist_by_avl_sizes.length &&
		  product.pricelist_by_avl_sizes[0].cost
			? product.pricelist_by_avl_sizes[0].cost
			: 0,
	  });
	  selectedImage = product.item_img;
	  if ($Basket.items.find((item) => item.item_num == product.item_num)) {
		product.pricelist_by_avl_sizes = [
		  ...$Basket.items.find((item) => item.item_num == product.item_num)
			.pricelist_by_avl_sizes,
		];
		product.pricelist_by_avl_sizes.forEach((priceItem) => {
		  if (!priceItem.messages) priceItem.messages = [];
		  if (priceItem.messages.length < priceItem.quantity)
			priceItem.messages = [
			  ...priceItem.messages,
			  ...new Array(priceItem.quantity - priceItem.messages.length),
			];
		  else if (priceItem.messages.length > priceItem.quantity)
			priceItem.messages = [
			  ...priceItem.messages.slice(
				0,
				priceItem.quantity - priceItem.messages.length
			  ),
			];
		});
		update = true;
	  }
	});
  $: date,
	() => {
	  let updateDate = isMobile ? date : moment(date).format("YYYY-MM-DD");
	  Basket.setDate(date);
	};
  //$: allowChange = product && $Basket.deleveryDate && product.pricelist_by_avl_sizes.reduce((t,c) => t+(c.quantity ? parseInt(c.quantity) : 0), 0);
  $: allowChange =
	product &&
	product.pricelist_by_avl_sizes.reduce(
	  (t, c) => t + (c.quantity ? parseInt(c.quantity) : 0),
	  0
	);
  // $('.multiple-items').slick({
  // 	infinite: true,
  // 	slidesToShow: 3,
  // 	slidesToScroll: 3
  // });
  let alreadyLoaded = false;
  const getReviews = async () => {
	//let res = await fetch('https://crm.mangomist.com/reviews?rating_gte=4&comment_null=false&product_id='+id);
	let res = await fetch(
		"https://crm.lamara.in/products/products/get_high_rated_reviews/"+
	  //"https://crm.mangomist.com/reviews?product_id=" +
		product.item_no 
		//+"&rating_gte=4"
	);
	res = await res.json();
	if(res.data)
		return res.data;
	else
		return [];
  };

  let isMobileDevice = false;

  onMount(() => {
    // Check if the device is mobile
    isMobileDevice = window.innerWidth <= 768; // Adjust the breakpoint to your desired screen size

    // Listen for window resize event
    window.addEventListener('resize', handleResize);
  });

  function handleResize() {
    isMobileDevice = window.innerWidth <= 768; // Adjust the breakpoint to your desired screen size
  }
</script>
<svelte:head>
  <script
	type="text/javascript"
	src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
  ></script>
  {#if product && product.id}
	{#await Products.getById(product.id) then meta}
	{#if meta && meta.Metadata && meta.Metadata.length}
	  {#if meta.Metadata.find((m) => m.metakey.slug == "keywords")}
		<meta
		  name="keywords"
		  content={meta.Metadata.find((m) => m.metakey.slug == "keywords")
			.value}
		/>
	  {/if}
	{/if}
	{/await}
  {/if}
</svelte:head>
{#if product}
  <section class="product-details-page">
	<div class="container">
	  <div class="wrapper row">
		<div class="preview col-md-6">
		  <div class="swipe-holder">
			<Swipe {...swipeConfig}>
			  <SwipeItem>
				<div class="preview-pic tab-content">
				  <div class="tab-pane active" id="pic-1">
					<img class="product-img-big" src={selectedImage} />
				  </div>
				</div>
			  </SwipeItem>
			  {#each product.gallery_imges as image}
				<SwipeItem>
				  <div>
					<img class="product-img-big" src={image} />
				  </div>
				</SwipeItem>
			  {/each}
			</Swipe>
		  </div>
		  <!-- <div class="preview-pic tab-content">
					<div class="tab-pane active" id="pic-1"><img class="product-img-big" src={selectedImage} /></div>
				</div> -->
		  {#if product.gallery_imges && product.gallery_imges.length}
			<ul class="preview-thumbnail nav nav-tabs">
			  <li class:active={selectedImage == product.item_img}>
				<a
				  href="#pic-1"
				  data-toggle="tab"
				  on:click|preventDefault={() =>
					(selectedImage = product.item_img)}
				>
				  <img src={product.item_img} />
				</a>
			  </li>
			  {#each product.gallery_imges as image}
				<li class:active={selectedImage == image}>
				  <a
					href="#pic-1"
					data-toggle="tab"
					on:click|preventDefault={() => (selectedImage = image)}
				  >
					<img src={image} />
				  </a>
				</li>
			  {/each}
			</ul>
		  {/if}
		</div>
		<div class="details col-md-6">
		  <h3 class="product-title">{product.name}</h3>
		  <!-- <div class="rating">
					<div class="stars">
						<span class="fa fa-star checked"></span>
						<span class="fa fa-star checked"></span>
						<span class="fa fa-star checked"></span>
						<span class="fa fa-star"></span>
						<span class="fa fa-star"></span>
					</div>
					<span class="review-no">41 reviews</span>
				</div> -->
		  <div class="product-detailed-description">
			<h6>Description:</h6>
			<p class="product-description">{product.description}</p>
		  </div>
		  <!-- <p class="vote"><strong>91%</strong> of buyers enjoyed this product! <strong>(87 votes)</strong></p> -->
		  <!-- <div class="form-group w-100">
					<label class="lbl-txt">Date:</label>
					{#if isMobile}
						<input class="form-control form-control-sm" type="date" placeholder="date" bind:value={$Basket.deleveryDate} min={moment().format("YYYY-MM-DD")}>
					{:else}
						<div class="row no-gutters">
							<span class="form-control form-control-sm col-8 text-center">{moment($Basket.deleveryDate).format('Do MMMM YYYY')}</span>
							<div class="col-4">
								<Datepicker class="col-4" start={new Date()} bind:selected={date} format={''}/>
							</div>
						</div>
					{/if}
				</div> -->
		  {#each product.pricelist_by_avl_sizes as priceItem}
			<div class="row sizes">
			  <div class="col-4 col-md-4 item-quantity">
				<button class="btn btn-default">{priceItem.size}</button>
			  </div>
			  <div class="col-4 col-md-4">
				{#if priceItem.select_max > 0}
				  <select
					class="form-control quantity-box"
					placeholder="Quantity"
					bind:value={priceItem.quantity}
					on:change={(e) => {
					  if (!priceItem.messages) priceItem.messages = [];
					  if (priceItem.messages.length < priceItem.quantity)
						priceItem.messages = [
						  ...priceItem.messages,
						  ...new Array(
							priceItem.quantity - priceItem.messages.length
						  ),
						];
					  else if (priceItem.messages.length > priceItem.quantity)
						priceItem.messages = [
						  ...priceItem.messages.slice(
							0,
							priceItem.quantity - priceItem.messages.length
						  ),
						];
					}}
				  >
					<option value="0">Quantity</option>
					<option value="0">0</option>
					{#each [...Array(parseInt(priceItem.select_max)).keys()] as i}
					  <option value={i + 1}>{i + 1}</option>
					{/each}
				  </select>
				{:else}
				  <p class="alert alert-danger">Out of stock</p>
				{/if}
			  </div>
			  <div class="col-4 col-md-4">
				<p class="item-cost">
				  &#8377; {priceItem.cost}
				</p>
			  </div>
			</div>
			{#if priceItem.quantity > 0}
			  <div class="form-group w-100">
				<label class="lbl-txt">Message:</label>
				{#if priceItem.messages}
				  {#each priceItem.messages as message, i}
					<input
					  class="form-control mb-2"
					  bind:value={message}
					  maxlength="40"
					  placeholder="Message on cake {i + 1}"
					/>
				  {/each}
				{/if}
			  </div>
			{/if}
		  {/each}
		  <div class="action">
			<button
			  type="button"
			  class="btn btn-primary"
			  disabled={!allowChange}
			  on:click|preventDefault={(e) => {
				product.pricelist_by_avl_sizes.forEach((size, i) => {
				  if (size.quantity && size.quantity > 0) {
					new Array(parseInt(size.quantity)).forEach((j, k) => {
					  if (!size.messages[k])
						product.pricelist_by_avl_sizes[i].messages[k] = "";
					});
				  } else {
					product.pricelist_by_avl_sizes[i].quantity = 0;
					product.pricelist_by_avl_sizes[i].messages = [];
				  }
				});
				if (update) {
				  Basket.updateItem(product);
				  notifications.success("Item has been updated successfuly!");
				} else {
				  Basket.add(product);
				  notifications.success("Item has been added to basket!");
				}
			  }}>{update ? "Update" : "Add to basket"}</button
			>
		  </div>
		</div>
	  </div>
	  <div>
		<p class="free-delivery-txt">Free delivery across Bengaluru.</p>
	  </div>
	</div>
	
	{#await getReviews() then reviews}
		{#if reviews.length}
			<hr />
			<div class="reviews-and-ratings">
				<div>
					<h3 class="section-title">Ratings & Reviews</h3>
				</div>
				{#if isMobileDevice}
					<Carousel particlesToShow={1} particlesToScroll={1} dots={false} let:showPrevPage
					let:showNextPage>
						<button slot="prev" on:click={showPrevPage} class="btn custom-arrow custom-arrow-prev">
							<i class="fa fa-angle-left" aria-hidden="true"></i>
						</button>
						{#each reviews as review}
							<div class="col-md-3 no-gutters col-12">
								<div
								class="home_reviews_min_ht"
								style="background: url('../images/reviews_bg.png')"
								>
								&nbsp;
								</div>
								<div class="content-wrapper">
								<span class="overlay" />
								<div class="title">
									<h5>{review.name}</h5>
									<span class="review_date">
									{moment(review.created_date).format("DD MMM, YYYY")}
									</span>
									<div class="comments">
									<p>{review.comments ? review.comments : ""}</p>
									</div>
								</div>
								<div class="star-wrapper">
									<div class="customer-stars style-2">
									<span class="inline-price">
										<div class="rating_bar">
										<div
											class="customer-rating"
											style="width:{parseInt(review.rating_val) * 20}%"
										/>
										</div>
									</span>
									</div>
								</div>
								</div>
							</div>
						{/each}
						<button slot="next" on:click={showNextPage} class="btn custom-arrow custom-arrow-next">
							<i class="fa fa-angle-right" aria-hidden="true"></i>
						</button>
					</Carousel>
				{:else}
					<Carousel particlesToShow={4} particlesToScroll={1} dots={false} let:showPrevPage
					let:showNextPage>
						<button slot="prev" on:click={showPrevPage} class="btn custom-arrow custom-arrow-prev">
							<i class="fa fa-angle-left" aria-hidden="true"></i>
						</button>
						{#each reviews as review}
							<div class="col-md-3 no-gutters col-12">
								<div
								class="home_reviews_min_ht"
								style="background: url('../images/reviews_bg.png')"
								>
								&nbsp;
								</div>
								<div class="content-wrapper">
								<span class="overlay" />
								<div class="title">
									<h5>{review.name}</h5>
									<span class="review_date">
									{moment(review.created_date).format("DD MMM, YYYY")}
									</span>
									<div class="comments">
									<p>{review.comments ? review.comments : ""}</p>
									</div>
								</div>
								<div class="star-wrapper">
									<div class="customer-stars style-2">
									<span class="inline-price">
										<div class="rating_bar">
										<div
											class="customer-rating"
											style="width:{parseInt(review.rating_val) * 20}%"
										/>
										</div>
									</span>
									</div>
								</div>
								</div>
							</div>
						{/each}
						<button slot="next" on:click={showNextPage} class="btn custom-arrow custom-arrow-next">
							<i class="fa fa-angle-right" aria-hidden="true"></i>
						</button>
				</Carousel>
				{/if}
			</div>
		{/if}
	{/await}
	<hr/>
	<div class="container-fluid">
	  <div>
		<h3 class="section-title">Similar Products</h3>
	  </div>
	  {#if similar_products && similar_products.length}
		<div class="row similar-cakes">
			{#if !isMobileDevice}
				<Carousel particlesToShow={4} particlesToScroll={1} dots={false} let:showPrevPage
				let:showNextPage>
					<button slot="prev" on:click={showPrevPage} class="btn custom-arrow custom-arrow-prev">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</button>
					{#each similar_products as s_product}
						<ListItem product={s_product} />
					{/each}
					<button slot="next" on:click={showNextPage} class="btn custom-arrow custom-arrow-next">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</button>
				</Carousel>
			{:else}
			<!-- TODO -->
			<!-- <Carousel particlesToShow={4} particlesToScroll={1} dots={false} infinite={false} let:showPrevPage
			let:showNextPage>
					<button slot="prev" on:click={showPrevPage} class="btn custom-arrow custom-arrow-prev">
						<i class="fa fa-angle-left" aria-hidden="true"></i>
					</button>
					{#each similar_products as s_product}
							<ListItem product={s_product} />
					{/each}
					<button slot="next" on:click={showNextPage} class="btn custom-arrow custom-arrow-next ">
						<i class="fa fa-angle-right" aria-hidden="true"></i>
					</button>
				</Carousel>
			{/if} -->
			<div class="col-md-3">
				{#each similar_products as s_product}
					<ListItem cssClass=" " product={s_product} />
				{/each}
			</div>
			{/if}
		</div>
	  {/if}
	</div>
	
	
  </section>
{/if}
<style lang="scss">
  .product-details-page {
	position: relative;
  }
  .swipe-holder {
	height: 30vh;
	width: 100%;
  }
  img {
	max-width: 100%;
	height: auto;
  }
  .product-details-page::before {
	content: " ";
	padding: 0;
	margin: 0;
	// background-image: url(/images/web-pattern-gold-body-6.png);
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	position: fixed;
	z-index: -1;
  }
  #reviewscarousel {
	margin: 40px 0 0 0;
  }
  .home_reviews_min_ht {
	min-height: 450px;
  }
  .content-wrapper {
	position: absolute;
	height: 100%;
	width: 100%;
	top: 0;
	padding: 30px;
  }
  .overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(15, 36, 83, 0.4);
	transition: all 0.3s ease;
  }
  .title {
	top: 0;
	font-family: var(--primary-font);
	position: relative;
	text-align: center;
	display: block;
	color: #fff;
	transition: all 0.3s ease;
  }
  .title h5 {
	font-family: var(--primary-font);
	color: #fff;
  }
  .comments p {
	color: #fff;
	font-family: var(--primary-font);
	text-align: center;
	margin-top: 10px;
  }
  .content-wrapper:hover .overlay {
	background-color: rgba(150, 122, 80, 0.7);
  }
  .star-wrapper {
	position: absolute;
	bottom: 45px;
	text-align: center;
	left: 0;
	right: 0;
  }
  .customer-stars.style-2 {
	background-color: #907650;
	border-color: #907650;
  }
  .customer-stars {
	border: 2px solid #967a50;
	border-radius: 3px;
	color: #967a50;
	display: inline-block;
	letter-spacing: 0.1rem;
	padding: 14px 36px;
	text-transform: uppercase;
	font-family: var(--primary-font);
	font-weight: 500;
	font-size: 1.125rem;
	-webkit-transition: all 0.3s ease;
	-moz-transition: all 0.3s ease;
	-ms-transition: all 0.3s ease;
	-o-transition: all 0.3s ease;
	transition: all 0.3s ease;
	height: 48px;
  }
  .rating_bar {
	background: rgba(0, 0, 0, 0) url(/images/stars.png) repeat-x scroll 0 0;
	text-align: left;
	width: 80px;
	max-width: 100%;
  }
  .customer-rating {
	background: rgba(0, 0, 0, 0) url(/images/stars.png) repeat-x scroll 0 -16px;
	height: 16px;
	text-align: center;
  }
  .carousel-btn {
	background: none;
	width: 40px;
	border: none;
  }
  img {
	max-width: 100%;
  }
  section {
	margin-top: 150px;
	padding-bottom: 100px;
	min-height: 60vh;
  }
  .preview {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
  }
  @media screen and (max-width: 996px) {
	.preview {
	  margin-bottom: 20px;
	}
  }
  .preview-pic {
	-webkit-box-flex: 1;
	-webkit-flex-grow: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
  }
  .preview-thumbnail.nav-tabs {
	border: none;
	margin-top: 15px;
  }
  .preview-thumbnail.nav-tabs li {
	width: 18%;
	margin-right: 2.5%;
  }
  .preview-thumbnail.nav-tabs li img {
	max-width: 100%;
	display: block;
  }
  .preview-thumbnail.nav-tabs li a {
	padding: 0;
	margin: 0;
  }
  .preview-thumbnail.nav-tabs li:last-of-type {
	margin-right: 0;
  }
  .tab-content {
	overflow: hidden;
  }
  .tab-content img {
	width: 100%;
	-webkit-animation-name: opacity;
	animation-name: opacity;
	-webkit-animation-duration: 0.3s;
	animation-duration: 0.3s;
  }
  .card {
	margin-top: 50px;
	padding: 3em;
	line-height: 1.5em;
  }
  @media screen and (min-width: 997px) {
	.wrapper {
	  display: -webkit-box;
	  display: -webkit-flex;
	  display: -ms-flexbox;
	  display: flex;
	}
  }
  .details {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-direction: column;
	-ms-flex-direction: column;
	flex-direction: column;
  }
  .colors {
	-webkit-box-flex: 1;
	-webkit-flex-grow: 1;
	-ms-flex-positive: 1;
	flex-grow: 1;
  }
  .product-title,
  .price,
  .sizes,
  .colors {
	text-transform: UPPERCASE;
	font-weight: bold;
  }
  .product-title:focus {
	outline: none;
	border: none;
  }
  .checked,
  .price span {
  }
  .product-title,
  .rating,
  .product-description,
  .price,
  .vote,
  .sizes {
	margin-bottom: 15px;
	font-family: var(--primary-font);
  }
  .product-title {
	margin-top: 0;
  }
  .size {
	margin-right: 10px;
  }
  .size .btn {
	color: var(--primary);
	min-width: 100px;
	margin-bottom: 6px;
	font-weight: 600;
	padding-top: 0;
	padding-bottom: 0;
	font-family: var(--primary-font);
	text-transform: uppercase;
	border: 1px solid var(--primary);
  }
  .size:first-of-type {
	margin-left: 40px;
  }
  .color {
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
	height: 2em;
	width: 2em;
	border-radius: 2px;
  }
  .color:first-of-type {
	margin-left: 20px;
  }
  .not-available {
	text-align: center;
	line-height: 2em;
  }
  .not-available:before {
	font-family: fontawesome;
	content: "\f00d";
	color: #fff;
  }
  .tooltip-inner {
	padding: 1.3em;
  }
  .sizes {
	align-items: center;
  }
  .item-cost {
	margin-bottom: 0;
  }
  .review-no {
	margin-top: 8px;
	display: block;
  }
  @-webkit-keyframes opacity {
	0% {
	  opacity: 0;
	  -webkit-transform: scale(3);
	  transform: scale(3);
	}
	100% {
	  opacity: 1;
	  -webkit-transform: scale(1);
	  transform: scale(1);
	}
  }
  @keyframes opacity {
	0% {
	  opacity: 0;
	  -webkit-transform: scale(3);
	  transform: scale(3);
	}
	100% {
	  opacity: 1;
	  -webkit-transform: scale(1);
	  transform: scale(1);
	}
  }
  .product-detailed-description h6 {
	font-family: var(--primary-font);
	font-size: 20px;
	font-weight: 600;
  }
  .product-img-big {
	max-height: 500px;
	border: 4px solid rgba(247, 195, 114, 1);
	border-radius: 10px;
  }
  :global(.swipe-indicator) {
	background: #000 !important;
	display: none !important;
  }
  :global(.swipe-holder) {
	height: auto !important;
	min-height: 404px;
  }
  .reviews-carousel {
	background: url("../images/reviews_bg.png") repeat-x center;
  }
  @media only screen and (min-width: 600px) and (max-width: 993px) {
	:global(.swipe-holder) {
	  min-height: 262px;
	}
  }
  @media only screen and (min-width: 320px) and (max-width: 359px) {
	:global(.swipe-holder) {
	  min-height: 230px;
	}
  }
  .section-title {
	padding: 25px 0 0px 0;
	margin-bottom: 24px;
	font-family: var(--primary-font);
	color: #434343;
	font-size: 26x;
	text-align: center;
  }

  .free-delivery-txt {
	margin: 20px 0;
	font-family: var(--primary-font);
	font-size: 18px;
  }

  hr {
	  margin-top: 40px;
  }

  .no-gutters {
	padding: 0 !important;
  }


  :global(.sc-carousel__arrow-container) {
    padding: 0 !important;
  }

	:global(.custom-arrow) {
		width: 50px !important;
		border-radius: 50%;
		height: 50px !important;
		background-color: rgba(0,0,0, 0.8) !important;
		color: #fff;;
	}

	:global(.custom-arrow i) {
		font-size: 28px;
	}

	:global(.custom-arrow-prev) {
    	position: absolute;
		z-index: 99;
		top: 50%;
		transform: translateY(-50%);
		left: 0;
	}

	:global(.custom-arrow-next) {
    	position: absolute;
		z-index: 99;
		top: 50%;
		transform: translateY(-50%);
		right: 0;
	}
	:global(.similar-cakes .col-md-4) {
		padding-right: 5px;
    	padding-left: 5px;
	}


	:global(.reviews-and-ratings .custom-arrow) {
		background-color: rgba(0,0,0, 1) !important;
	}

	@media only screen and (min-width: 360px) and (max-width: 400px) {
	:global(.swipe-holder) {
	  min-height: 278px;
	}

	:global(.custom-arrow) {
		width: 35px !important;
		height: 35px !important;
  	}

	  :global(.custom-arrow i) {
		  font-size: 20px;
	  }
	}
  @media only screen and (min-width: 401px) and (max-width: 599px) {
	:global(.swipe-holder) {
	  min-height: 313px;
	}
  }
</style>